const urlScoringApi = process.env.REACT_APP_SCORING_PROGRAMS_API_URL;

export const postScoringPrograms = async (data: any, token: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_SCORING_PROGRAMS_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlScoringApi}post_scoring_programs`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const getScoringPrograms = async ({ token }) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_SCORING_PROGRAMS_XAPIKEY
        }
    };
    const urlRequest = `${urlScoringApi}get_scoring_programs`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};


export const putScoringPrograms = async (data: any, token: string) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_SCORING_PROGRAMS_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlScoringApi}put_scoring_programs`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

